export default "<p>flag-lesson-modal works!</p>\r\n";